<template>
  <div>
    <!-- <div class="search">
      <el-input
        style="width:200px;margin-right:10px"
        :placeholder="$t('system::rbac::搜索姓名或手机号码')"
        v-model="searchValue"
      >
        <el-button slot="append" icon="el-icon-search" type="primary" @click="search"></el-button>
      </el-input>
      <el-button type="primary" @click="isShowAdd = true" icon="el-icon-plus" :disabled="!role.roleId">
        {{ $t('system::rbac::添加员工') }}
      </el-button>
    </div> -->
    <z-table :columns="columns" :data="data" :pagination="false" v-loading="loading" height="600px">
      <template #loginName="{ row }">
        <span>{{ row.loginName || '--' }}</span>
      </template>
      <template #accountNumber="{ row }">
        <span>{{ row.accountNumber || '--' }}</span>
      </template>
      <template #merchantName="{ row }">
        <span>{{ row.merchantName || '--' }}</span>
      </template>
      <template #handle="{ row }">
        <el-button type="text" style="color: #e62c11" @click="remove(row)">{{ $t('system::rbac::移除') }}</el-button>
      </template>
    </z-table>
    <AddStaff v-model="isShowAdd" :roleId="role.roleId" @refresh="refresh"></AddStaff>
  </div>
</template>

<script>
import AddStaff from './components/add-staff.vue'
import { getAccountList, removeAccountForRole } from '@/server/system'
export default {
  components: { AddStaff },
  props: {
    role: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      searchValue: '',
      loading: false,
      columns: [
        // {
        //   type: 'selection'
        // },
        {
          prop: 'loginName',
          label: this.$t('system::rbac::账号姓名'),
          width: '200px',
        },
        {
          prop: 'accountNumber',
          label: this.$t('system::rbac::账号'),
          minWidth: '200px',
        },
        // {
        //   prop: 'merchantName',
        //   label: '企业',
        //   minWidth: '200px'
        // },
        {
          prop: 'handle',
          label: this.$t('system::rbac::opt'),
          width: '100px',
        },
      ],
      data: [],
      isShowAdd: false,
    }
  },
  mounted() {
    if (this.role.roleId) {
      this.getAccountList()
    }
  },
  methods: {
    async getAccountList(str) {
      this.loading = true
      const data = await getAccountList({ roleId: this.role.roleId, systemId: 3, keywords: str || this.searchValue })
      if (data.data.code === this.$code) {
        this.data = data.data.data
      }
      this.loading = false
    },
    search(str) {
      if (this.role.roleId) {
        this.getAccountList(str)
      }
      console.log('role')
    },
    refresh() {
      this.getAccountList()
      this.$emit('refresh')
    },
    remove(item) {
      this.$confirm(
        `<div>${this.$t('system::rbac::staff_title')}</div><div>${this.$t('system::rbac::staff_tip')}</div>`,
        this.$t('system::rbac::删除用户'),
        {
          confirmButtonText: this.$t('system::common::btn::confirm'),
          cancelButtonText: this.$t('system::common::btn::cancel'),
          dangerouslyUseHTMLString: true,
        }
      ).then(() => {
        this.removeStaff(item)
      })
    },
    async removeStaff(staff) {
      const data = await removeAccountForRole({ roleId: this.role.roleId, userIds: [staff.userId] })
      if (data.data.code === this.$code) {
        this.$message.success(this.$t('system::tip::delete_success'))
        this.refresh()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.search {
  margin-bottom: 16px;
  /deep/.el-input-group__append {
    padding: 0 12px;
    background: #0560fd !important;
    color: #fff !important;
    border: 1px solid #0560fd;
  }
}
</style>
